import SanityTable from '~/components/sanity/SanityTable.vue';
import { urlFor } from '~/utils/sanity';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import ContainerVue from '~/components/sanity/Container.vue';
export default {
  name: 'Grid',
  components: {
    ContainerVue,
    SanityBlockContent,
    SanityTable
  },
  props: {
    desktop: Object,
    mobile: Object,
    styles: Object
  },
  computed: {
    style() {
      if (!this.styles) {
        return {
          color: '#FFFFFF',
          backgroundColor: '#000000'
        };
      }
      let style = {
        color: this.styles.color || '#FFFFFF'
      };
      if (this.styles.backgroundType === 'image') {
        style = {
          ...style,
          backgroundImage: `url(${this.imageUrl(this.styles.backgroundImage)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      } else if (this.styles.backgroundType === 'color') {
        style.backgroundColor = this.styles.backgroundColor;
      } else {
        style.backgroundColor = '#000000';
      }
      return style;
    }
  },
  methods: {
    imageUrl(image) {
      return urlFor(image);
    },
    columnStyle(styles) {
      const style = {
        ...styles
      };
      return style;
    }
  }
};